import { useTranslation } from "react-i18next";
import { ScanFace } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";
import { FaceEnrollButton } from "./FaceEnrollButton";

// Reference photos are mandatory: this banner keeps every new employee visible until enrolled.
export const MissingFaceBanner = ({ employees, onDone }) => {
  const { t } = useTranslation();
  const pending = employees.filter((e) => !e.face_enrolled);
  if (!pending.length) return null;

  return (
    <NeuCard className="border border-warning/40 p-5" data-testid="missing-face-banner">
      <div className="flex items-center gap-2 text-warning">
        <ScanFace className="h-5 w-5" />
        <p className="text-sm font-bold">{t("employees.missingFaceTitle", { count: pending.length })}</p>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">{t("employees.missingFaceHint")}</p>
      <ul className="mt-4 divide-y divide-border/50">
        {pending.map((e) => (
          <li key={e.id} className="flex flex-wrap items-center justify-between gap-3 py-3" data-testid={`missing-face-${e.id}`}>
            <div className="min-w-0">
              <p className="truncate text-sm font-bold">{e.name}</p>
              <p className="truncate text-xs text-muted-foreground">{e.email}</p>
            </div>
            <FaceEnrollButton userId={e.id} enrolled={false} onDone={onDone} />
          </li>
        ))}
      </ul>
    </NeuCard>
  );
};
